export const Footer = () => (
  <footer className="border-t border-hairline" data-testid="site-footer">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-8 py-10">
      <p className="font-label sc text-[12px] tracking-[0.14em] text-inkmuted" data-testid="footer-nap">
        Sandquist Construction · 1172 San Pablo Avenue, Suite 200C, Berkeley, CA 94706 ·{" "}
        <a href="tel:+15106041250" className="text-plaster hover:text-ink transition-colors duration-200" data-testid="footer-phone">
          (510) 604-1250
        </a>{" "}
        · <span data-testid="footer-license">CA License #572537</span>
      </p>
    </div>
  </footer>
);
